import cn from 'classnames';
import styles from './ChatTyping.module.scss';

type ChatTypingProps = {
  className?: string;
};

const ChatTyping = ({ className }: ChatTypingProps) => (
  <div className={cn(styles.root, className)}>
    <span className={styles.text}>typing</span>

    <div className={styles.typing}>
      <span className={styles.typingInner} />
    </div>
  </div>
);

export default ChatTyping;
